export const OAUTH_EDIT_REQUEST = "OAUTH_EDIT_REQUEST";

export const OAUTH_EDIT_SUCCESS = "OAUTH_EDIT_SUCCESS";

export const OAUTH_EDIT_FAIL = "OAUTH_EDIT_FAIL";

export const OAUTH_EDIT_RESET = "OAUTH_EDIT_RESET";

export const OAUTH_UPDATE_REQUEST = "OAUTH_UPDATE_REQUEST";

export const OAUTH_UPDATE_SUCCESS = "OAUTH_UPDATE_SUCCESS";

export const OAUTH_UPDATE_FAIL = "OAUTH_UPDATE_FAIL";

export const OAUTH_UPDATE_RESET = "OAUTH_UPDATE_RESET";

export const OAUTH_DELETE_REQUEST = "OAUTH_DELETE_REQUEST";

export const OAUTH_DELETE_SUCCESS = "OAUTH_DELETE_SUCCESS";

export const OAUTH_DELETE_FAIL = "OAUTH_DELETE_FAIL";

export const OAUTH_DELETE_RESET = "OAUTH_DELETE_RESET";

/* Facebook Pages */

export const OAUTH_FACEBOOK_PAGES_REQUEST = "OAUTH_FACEBOOK_PAGES_REQUEST";

export const OAUTH_FACEBOOK_PAGES_SUCCESS = "OAUTH_FACEBOOK_PAGES_SUCCESS";

export const OAUTH_FACEBOOK_PAGES_FAIL = "OAUTH_FACEBOOK_PAGES_FAIL";

export const OAUTH_FACEBOOK_PAGES_RESET = "OAUTH_FACEBOOK_PAGES_RESET";

export const OAUTH_FACEBOOK_PAGE_SELECT_REQUEST =
  "OAUTH_FACEBOOK_PAGE_SELECT_REQUEST";

export const OAUTH_FACEBOOK_PAGE_SELECT_SUCCESS =
  "OAUTH_FACEBOOK_PAGE_SELECT_SUCCESS";

export const OAUTH_FACEBOOK_PAGE_SELECT_FAIL =
  "OAUTH_FACEBOOK_PAGE_SELECT_FAIL";

export const OAUTH_FACEBOOK_PAGE_SELECT_RESET =
  "OAUTH_FACEBOOK_PAGE_SELECT_RESET";

/* Instagram Accounts */

export const OAUTH_INSTAGRAM_ACCOUNTS_REQUEST =
  "OAUTH_INSTAGRAM_ACCOUNTS_REQUEST";

export const OAUTH_INSTAGRAM_ACCOUNTS_SUCCESS =
  "OAUTH_INSTAGRAM_ACCOUNTS_SUCCESS";

export const OAUTH_INSTAGRAM_ACCOUNTS_FAIL = "OAUTH_INSTAGRAM_ACCOUNTS_FAIL";

export const OAUTH_INSTAGRAM_ACCOUNTS_RESET = "OAUTH_INSTAGRAM_ACCOUNTS_RESET";

export const OAUTH_INSTAGRAM_ACCOUNT_SELECT_REQUEST =
  "OAUTH_INSTAGRAM_ACCOUNT_SELECT_REQUEST";

export const OAUTH_INSTAGRAM_ACCOUNT_SELECT_SUCCESS =
  "OAUTH_INSTAGRAM_ACCOUNT_SELECT_SUCCESS";

export const OAUTH_INSTAGRAM_ACCOUNT_SELECT_FAIL =
  "OAUTH_INSTAGRAM_ACCOUNT_SELECT_FAIL";

export const OAUTH_INSTAGRAM_ACCOUNT_SELECT_RESET =
  "OAUTH_INSTAGRAM_ACCOUNT_SELECT_RESET";
